import React, { Component } from 'react'
import { FieldArray } from 'formik'
import HigherOrderField from './higher-order-field.component'
import RadioButton from './radio-button.component'
import { StyledRadioGroup } from './styles/styled-radio-group.style'

/**
 * @param {string} gap
 * set the column gap if needed
 */
class RadioButtonGroup extends Component {
	render() {
		const { id, gap, children } = this.props
		return (
			<HigherOrderField {...this.props}>
				<FieldArray
					name={id}
					render={() => (
						<StyledRadioGroup gap={gap}>{children}</StyledRadioGroup>
					)}
				/>
			</HigherOrderField>
		)
	}
}

export default RadioButtonGroup
